import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { QuotationModel } from './models/quotation.model'
import { QuotationFields } from './models/quotation_fields.model'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class QuotationService {
  constructor(private http: HttpClient) {}

  addQuotation(quotation: QuotationModel) {
    
    return this.http
      .post(API_URL + '/Quotation/CreateQuotation', quotation, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  updateQuotation(quotation: QuotationModel) {
    
    return this.http
      .put(API_URL + '/Quotation/UpdateQuotation', quotation, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllQuotations(): Observable<QuotationModel[]> {
    return this.http
      .get(API_URL + '/Quotation/GetQuotations', {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          

          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getQuotationById(quotationId: number): Observable<QuotationModel> {
    return this.http
      .get(API_URL + '/Quotation/GetQuotationById', {
        params: {
          id: quotationId,
        },
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          

          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  deleteQuotation(quotation: QuotationModel) {
      
      return this.http
        .put(API_URL + '/Quotation/DeleteQuotation', quotation, {
          withCredentials: true,
        })
        .pipe(
          map((response: any) => {
            return response
          }),
          catchError((error: any) => {
            

            throw new HttpErrorResponse({
              status: error.error.statusCode,
              statusText: error.error.response,
            })
          }),
        )
    }
}
